import {
  GET_REGISTER_ENTITY_TYPES,
  LOGIN_URL,
  normalize_user_role,
  REGISTER_USER,
  REGISTER_USER_ENTITY,
  URL_FORGOT_PASSWORD
} from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import { password_visibility_mixin } from '@/utils/mixins/password_visibility_mixin.js';
import {
  validate_non_empty_string,
  validate_phone_number
} from '@/utils/validations/validate_inputs';
import OnboardingIndex from '@/views/onboarding/OnboardingIndex.vue';
import axios from 'axios';


export default {
   name: 'SignUp',
   mixins: [alert_mixin, password_visibility_mixin],
  components:{
    OnboardingIndex
  },
  data: () => ({
    show_password: false, // Toggle for password visibility
    show_confirm_password: false,
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    password: '',
    confirm_password: '',
    entity_type_id :'',
    eye_icon: 'bi-eye-slash',
    url_forgot_password: URL_FORGOT_PASSWORD,
    url_login:LOGIN_URL,
    verification_running: false,
    title: "Create Your Account",
    submit_button_text: "Register",
    entity_type_list :[],
    dec_project_id:'',
    token:'',
    user_id: null,
    from_jobs_advertised: false,
    selected_job_title: '',
    entity_types_loaded: false,
 }),

  mounted() {
    this.get_default_entity_types();
  },

  methods: {

    get_default_entity_types(){
      const project_id = this.$route.params.project_id || ""

      return axios.get(GET_REGISTER_ENTITY_TYPES,{
        params: { project_id: project_id }
      })
      .then(response => {
          const response_data = response.data;

          if (response_data.status === 'success') {
              this.dec_project_id = response_data.project_id
              const mapped_request_data = response_data.data.map(entity_type => ({
                  "id": entity_type.id,
                  "name": entity_type.entity_type_name,
                }),
              );

              this.entity_type_list = mapped_request_data

              // Auto-select job if coming from jobs_advertised Apply button
              const apply_job_id = sessionStorage.getItem('apply_job_id');
              const apply_job_title = sessionStorage.getItem('apply_job_title');
              if (apply_job_id) {
                const job_id_num = Number(apply_job_id);
                let match = this.entity_type_list.find(et => et.id === job_id_num);

                // If the specific job isn't in the default list, add it
                if (!match && apply_job_title) {
                  match = { id: job_id_num, name: apply_job_title };
                  this.entity_type_list.unshift(match);
                }

                if (match) {
                  this.entity_type_id = match.id;
                  this.from_jobs_advertised = true;
                  this.selected_job_title = apply_job_title || match.name;
                }
                // Clear so it doesn't persist on refresh
                sessionStorage.removeItem('apply_job_id');
                sessionStorage.removeItem('apply_job_title');
              }
          } else {
              this.show_error('Error fetching requests');
          }
      })
      .catch(error => {
          if (error.response && error.response.data) {
              this.show_error(error.response.data.message);
          }
      })
      .finally(() => {
          this.entity_types_loaded = true;
      });
    },


    async sign_up_function(){
  if (this.verification_running) return;

  if (!this.validate_register_entity_user_inputs()) return;

  this.verification_running = true;

  // Ensure entity types are loaded so profile form gets assigned
  if (!this.entity_types_loaded) {
    await this.get_default_entity_types();
  }

  // If still no entity type after loading, try one more time
  if (!this.entity_type_id && !this.entity_types_loaded) {
    await this.get_default_entity_types();
  }

  const data = {
    first_name:this.first_name,
    last_name:this.last_name,
    email:this.email,
    phone_number:this.phone_number,
    password: this.password,
    project_id : this.dec_project_id
  };

  // Only use the entity registration endpoint when the user explicitly came from a job apply flow.
  const parsed_entity_id = Number(this.entity_type_id);
  const has_entity_type =
    this.from_jobs_advertised &&
    parsed_entity_id &&
    Number.isInteger(parsed_entity_id) &&
    parsed_entity_id > 0;
  let register_url;
  if (has_entity_type) {
    data.entity_type_id = parsed_entity_id;
    register_url = REGISTER_USER_ENTITY;
  } else {
    // Standard self-registration should not silently bind the user to a job profile.
    register_url = REGISTER_USER;
  }

  axios.post(register_url, data)
  .then(response => {
    var response_data = response.data;

    // Parse if response is a string
    if (typeof response_data === 'string') {
      try {
        response_data = JSON.parse(response_data);
      } catch (e) {
        return this.show_error('Error parsing registration response');
      }
    }

    if (response_data.status === 'success') {

      this.token = response_data.token;
      this.user_id = response_data.user_id;

      sessionStorage.setItem('user_id', response_data.user_id);
      sessionStorage.setItem('token', response_data.token);
      sessionStorage.setItem('user_role', normalize_user_role(response_data.role_type));

      this.handle_successful_registration(response_data.user_id);

    } else {
      this.show_error(response_data.message || 'Registration failed');
    }
  })
  .catch(error => {

    if (error.response && error.response.data) {

      let error_data = error.response.data;

      // Parse if backend returns a string
      if (typeof error_data === 'string') {
        try {
          error_data = JSON.parse(error_data);
        } catch (e) {
          return this.show_error('Error occurred while processing request');
        }
      }

      const message = error_data.message || 'Error: email or phone number already exists';

      // Redirect to login if account already exists
      if (message === "Account already exists") {

        this.show_error("Account already exists. Please login instead.")
        this.$router.push('/login');

      } else {

        this.show_error(message);

      }

    } else {

      this.show_error('Error: Something went wrong');

    }
  })
  .finally(() => {
    this.verification_running = false;
  });
},

    validate_register_entity_user_inputs() {
      if (!validate_non_empty_string(this.first_name)) {
          this.show_error('First name must not be empty');
          return false;
      }

      if (!validate_non_empty_string(this.last_name)) {
          this.show_error('Last name must not be empty');
          return false;
      }
      if (!validate_non_empty_string(this.email)) {
        this.show_error('Email must not be empty');
        return false;
      }
      if (!validate_non_empty_string(this.phone_number)) {
        this.show_error('Phone number must not be empty');
        return false;
      }

      if (this.password !== this.confirm_password) {
        this.show_info('Passwords do not match.');
        return false;
      }

      return true;
    },
    async handle_successful_registration() {
      sessionStorage.setItem('first_time_login', true);
      // Registration already dispatches the OTP on the backend.
      const token = this.token;
      const user_id = this.user_id;
      this.$router.push({
        path: '/one_time_pin',
        query: {
          user_id,
          token,
        }
      });
    },

    validate_phone_number(phone_number) {
      return validate_phone_number(phone_number)
    }
  },
};
